<template>
  <div class="subtitle-guidance" v-show="isShow">
    <div
      class="subtitle-tip-box"
      v-for="(t,i) in tips"
      :style="{
        width: t.button.w + 'px',
        height: t.button.h + 'px',
        top: t.button.y + 'px',
        left: t.button.x + 'px'
      }"
      v-show="step == i"
    >
      <div class="tip-box-timeline" v-if="i == 1">
        <div>{{t.button.text + i}}</div>
      </div>
      <div class="tip-box-ai" v-else-if="i == 2">
        <div class="icon"></div>
        <div>智能识别</div>
      </div>
      <div class="tip-box-btn" v-else>{{t.button.text}}</div>
      <div class="tip-box-line"
        :style="{
          width: t.tip.w + 'px',
          height: t.tip.h + 'px',
          top: t.tip.y + 'px',
          left: t.tip.x + 'px',
          backgroundImage: `url(${t.tip.url})`
        }"
      ></div>
      <div class="tip-box-content"
        :style="{
          width: t.content.w + 'px',
          height: t.content.h + 'px',
          top: t.content.y + 'px',
          left: t.content.x + 'px'
        }"
      >
        <p>{{t.content.text}}</p>
        <div @click="next">{{i != 3 ? '下一步' : 'OK'}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return{
      isShow: false,
      tips:[
        {
          button: {
            x: 0,
            y: 0,
            w: 88,
            h: 34,
            text: "插入字幕"
          },
          tip: {
            x: 0,
            y: -46,
            w: 107,
            h: 43,
            url: '../../../static/svg/subtitle/tipline01.svg'
          },
          content: {
            x: 0,
            y: -60,
            w: 276,
            h: 121,
            text: "点击插入字幕，可快速在当前视频位置添加你想要的字幕文案。"
          }
        },{
          button: {
            x: 0,
            y: 0,
            w: 0,
            h: 0,
            text: "这里是字幕..."
          },
          tip: {
            x: 120,
            y: -65,
            w: 99,
            h: 61,
            url: '../../../static/svg/subtitle/tipline01.svg'
          },
          content: {
            x: 225,
            y: -147,
            w: 276,
            h: 121,
            text: "字幕时间轴，支持灵活调整每一段字幕的出入场位置及停留时长。"
          }
        },{
          button: {
            x: 0,
            y: 0,
            w: 0,
            h: 0,
            text: "智能识别"
          },
          tip: {
            x: 0,
            y: 20,
            w: 98,
            h: 55,
            url: '../../../static/svg/subtitle/tipline02.svg'
          },
          content: {
            x: 0,
            y: 81,
            w: 276,
            h: 121,
            text: "支持将视频中的音频内容智能识别一键转为字幕，会员功能现在限免试用哦！"
          }
        },{
          button: {
            x: 0,
            y: 12,
            w: 112,
            h: 36,
            text: "返回画布"
          },
          tip: {
            x: -47,
            y: 45,
            w: 93,
            h: 66,
            url: '../../../static/svg/subtitle/tipline03.svg'
          },
          content: {
            x: -276,
            y: 120,
            w: 276,
            h: 121,
            text: "点击即保存字幕并回到视频编辑模式，下次可再次进入继续字幕制作。"
          }
        }
      ],
      step: 0
    }
  },
  computed: {
    ...mapGetters([
      'UserMsg'
    ])
  },
  watch : {
    'UserMsg.versionNumber' : function(val, oldval){
      if(this.UserMsg.versionNumber > 400 && this.UserMsg.versionNumber < this.UserMsg.versionTOOL){
        if(!localStorage.getItem('hasUseSubtitle')){
          this.isShow = true;
          this.initStyle()
        }
      }
    },
  },
  mounted() {
    if(!localStorage.getItem('hasUseSubtitle')){
      this.isShow = true;
      this.initStyle()
    }
  },
  methods: {
    initStyle(){
      this.$nextTick(() => {
        let dx = window.scrollX,
            dy = window.scrollY,
            box = {x: 0, y: 0, w: 0, h: 0};

        ({left: box.x, top: box.y, width: box.w, height: box.h} = $(".timeline-subtitle .add-subtitle")[0].getBoundingClientRect())
        box.x+=dx
        box.y+=dy
        Object.assign(this.tips[0].button, box);
        this.tips[0].tip.x = box.w / 2;
        this.tips[0].content.x = 113 + box.w / 2;
        // ----------第一个----------
        ({left: box.x, top: box.y, width: box.w, height: box.h} = $(".timeline-subtitle .timeline-body")[0].getBoundingClientRect())
        box.x+=(dx + 10)
        box.y+=(dy + 30)
        box.w-=10
        box.h = 30
        Object.assign(this.tips[1].button, box);
        // ----------第二个----------
        ({left: box.x, top: box.y, width: box.w, height: box.h} = $(".editToolbar .ai_discern_button")[0].getBoundingClientRect())
        box.x+=dx
        box.y+=dy
        Object.assign(this.tips[2].button, box);
        this.tips[2].tip.x = box.w + 7
        this.tips[2].content.x = box.w + 56
        // ----------第三个----------
        if(this.$route.subtitle) {
          this.tips[3].button.w = 80
          this.tips[3].button.text = '导出'
          this.tips[3].content.text = '完成字幕之后点击导出为作品，在我的创作-我的作品中查看。'
        }
        this.tips[3].button.x = window.innerWidth - this.tips[3].button.w - 10
      })
    },
    next() {
      this.step++
      if(this.step === 4) {
        this.isShow = false
        localStorage.setItem('hasUseSubtitle', true)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.subtitle-guidance {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,.6);
  z-index: 999;
}
.subtitle-tip-box {
  position: relative;
}
.tip-box-btn{
  position: absolute;
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 100%;
  height: 100%;
  color: #ffffff;
  background-color: #5778FB;
  font-size: 14px;
  border-radius: 4px;
}
.tip-box-timeline {
  position: absolute;
  background-color: #D4D6E7;
  width: 100%;
  height: 100%;
  border-radius: 4px;

  div {
    margin-left: 88px;
    width:99px;
    height:30px;
    line-height: 30px;
    background-color: #8F92AF;
    color: #ffffff;
    font-size: 14px;
  }
}
.tip-box-ai {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #FAFAFF;
  width: 100%;
  height: 100%;
  padding: 0 10px;
  border-radius: 4px;

  color: #474261;
  font-weight: bold;
  line-height: 34px;

  .icon {
    width: 16px;
    height: 13px;
    background: url("../../../static/svg/subtitle/ai-discern.svg") no-repeat
      center;
  }

  &:before {
    position: absolute;
    top: -50%;
    left: 100%;
    transform: translate(-50%, 50%);
    content: "限免";
    width: 36px;
    height: 16px;
    background: linear-gradient(
      108deg,
      rgba(54, 51, 47, 1) 0%,
      rgba(18, 16, 10, 1) 100%
    );
    border-radius: 8px;

    color: #f8dbb2;
    font-size: 12px;
    font-weight: bold;
    line-height: 16px;
  }
}
.tip-box-line {
  position: absolute;
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.tip-box-content {
  position: absolute;
  background-color: #ffffff;
  padding: 19px 21px;
  border-radius: 4px;

  p {
    text-align: left;
    color: #333333;
    font-size:14px;
    text-align: justify;
  }

  div {
    position: absolute;
    right: 19px;
    bottom: 21px;
    width: 52px;
    height: 22px;
    background-color: #5778FB;
    color: #ffffff;
    text-align: center;
    line-height: 22px;
    border-radius: 11px;
    font-size: 12px;
    cursor: pointer;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/subtitle/subtitleGuidanceOld.vue